import React from 'react';
import konnectzit from '../../images/integrations/KonnectzIt.svg';
import IntegrationBot from '../../components/integrationn/index';

const KonnectzIT = () => <IntegrationBot botLogo={konnectzit} botName={'KonnectzIT'} />;

export default KonnectzIT;
